<template>
  <div class="dashboard-page">
    <div class="container">
      <div class="bg--white border-radius m-t-25 m-b-25 p-30">
        <h1>Dashboard</h1>

        <!-- Switch Buttons -->
        <div class="m-t-20 m-b-20">
          <button
              v-for="view in views"
              :key="view.name"
              :class="['tab-button', { active: currentView === view.name }]"
              @click="currentView = view.name"
          >
            {{ view.label }}
          </button>
        </div>

        <!-- Dynamic component -->
        <component :is="currentViewComponent" />
      </div>
    </div>

    <router-view
        name="childview"
    />
  </div>
</template>

<script>
import ReservationMonthOverview from '../../components/ReservationMonthOverview.vue';
import ReservationYearOverview from '../../components/ReservationYearOverview.vue';

export default {
  name: 'Dashboard',
  components: {
    ReservationMonthOverview,
    ReservationYearOverview,
  },
  data() {
    return {
      menu: [],
      currentUrl: window.location.href,
      currentView: 'ReservationMonthOverview',
      views: [
        { name: 'ReservationMonthOverview', label: 'Maandoverzicht' },
        { name: 'ReservationYearOverview', label: 'Jaaroverzicht' },
      ],
    };
  },
  computed: {
    currentViewComponent() {
      return this.currentView;
    },
  },
  created() {
    let userInterface = null;

    if (
        this.$userInterfaceHandler &&
        typeof this.$userInterfaceHandler.getUserInterface === 'function'
    ) {
      userInterface = this.$userInterfaceHandler.getUserInterface();
    }

    if (userInterface) {
      this.menu = userInterface.menu;
    }
  },
};
</script>